export const getFileSizeStr = (fileSize: number): string => {
  if (fileSize < 1024) {
    return `${fileSize} Byte`;
  } else if (fileSize < 1024 * 1024) {
    return `${(fileSize / 1024).toFixed(0)} KB`;
  } else if (fileSize < 1024 * 1024 * 1024) {
    return `${(fileSize / (1024 * 1024)).toFixed(0)} MB`;
  } else {
    return `${(fileSize / (1024 * 1024 * 1024)).toFixed(0)} GB`;
  }
};